import React from "react";
import ChatListItem from "./ChatListItem";

function ChatListLoader() {
  return (
    <div className="space-y-2 p-4">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex items-center gap-3 p-3 animate-pulse">
          <div className="w-12 h-12 bg-gray-200 rounded-full" />
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
            <div className="h-3 bg-gray-100 rounded w-40" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Sidebar({
  uniqueChats = [],
  selectedPhone,
  onSelectChat,
  isConnected,
  loadingChats,
  searchText,
  setSearchText,
  highlightText,
  activeTab,
  setActiveTab,
}) {
  // WA-06: conversationStatus is computed server-side (fixspire-service-whatsapp's
  // GET /api/messages) from each conversation's most recent INBOUND message only -- never
  // recomputed here from raw messages, per the ticket's explicit "backend-driven, don't trust
  // the frontend to compute this" requirement. Defaults to "inactive" if a chat somehow lacks
  // the field (e.g. stale cached data), matching the backend's own no-inbound-ever default.
  const activeChats = uniqueChats.filter(
    (chat) => (chat.conversationStatus || "inactive") === "active"
  );
  const inactiveChats = uniqueChats.filter(
    (chat) => (chat.conversationStatus || "inactive") === "inactive"
  );
  const visibleChats = activeTab === "active" ? activeChats : inactiveChats;

  return (
    <div className="w-full h-full bg-white shadow-lg flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-gray-800">Messages</h1>
          <div
            className={`w-3 h-3 rounded-full ${isConnected ? "bg-green-500" : "bg-red-500"
              }`}
          />
        </div>

        {/* Tabs - Capsule Style */}
        <div className="flex gap-1 mb-4 bg-gray-100 p-1 rounded-full">
          <button
            onClick={() => setActiveTab("active")}
            className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition ${activeTab === "active"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600"
              }`}
          >
            Active{" "}
            {activeChats.length > 0 && (
              <span className="ml-1">{activeChats.length}</span>
            )}
          </button>
          <button
            onClick={() => setActiveTab("inactive")}
            className={`flex-1 py-2 px-4 rounded-full text-sm font-medium transition ${activeTab === "inactive"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600"
              }`}
          >
            Inactive
          </button>
        </div>

        {/* Search */}
        <input
          type="text"
          placeholder="Search conversations..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="w-full px-4 py-2 bg-gray-100 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Chat List */}
      <div className="flex-1 overflow-y-auto">
        {loadingChats ? (
          <ChatListLoader />
        ) : uniqueChats.length === 0 ? (
          <div className="text-gray-400 text-center p-8">
            <svg
              className="w-16 h-16 mx-auto mb-4 text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <p className="text-sm">
              {searchText ? "No conversations found" : "No messages yet"}
            </p>
          </div>
        ) : visibleChats.length === 0 ? (
          <div className="text-gray-400 text-center p-8">
            <p className="text-sm">
              {activeTab === "active" ? "No active conversations" : "No inactive conversations"}
            </p>
          </div>
        ) : (
          visibleChats.map((msg) => (
            <div key={msg.phone_number}>
              <ChatListItem
                message={msg}
                isSelected={selectedPhone === msg.phone_number}
                onSelect={() => onSelectChat(msg.phone_number)}
                highlightText={highlightText}
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}